/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Tomáš Burian (burian@cadwork.cz)
 *
 */

import RenderDocument from "App/render_document";
import View from "App/view/view";
import ExaminerControls from "App/view/controls/examiner_controls";
import CameraStereo from "App/view/cameras/camera_stereo";
import {EViewControls} from "js_interface/src/modules/view_controls/scene_view_controls_enums";

/**
 * Controls behaviour for view.
 *
 * Camera cannot be stored here (just used) because we want to be able to change camera type on the fly and
 * don't want controls to be dependent on it.
 *
 * @param {object} aDocument render document
 * @param {object} aView View instance
 * @constructor
 */
export default
class ExaminerControlsStereo extends ExaminerControls {
    constructor(aDocument: RenderDocument, aView: View) {
        super(aDocument, aView);

        this._camera = new CameraStereo(this._view);
        this._initCameraParams();

        // enable input device for stereo mode
        this.setEnableDeviceInput(true, false);
    }

    public init() {
        // this.oldTexturesResolutionLimitRT =TextureNode.texturesResolutionSwitchLimitRT;
        // Renderer.setTexturesResolutionSwitchLimitRT(512.0);
    }

    public destroy() {
        // Renderer.setTexturesResolutionSwitchLimitRT(this.oldTexturesResolutionLimitRT);
    }

    public getControlsType(): EViewControls {
        return EViewControls.EXAMINER_STEREO;
    }

    public restrictCameraToGround() {
        // do not restrict camera to ground
    }

    public onTouchStart(x: number, y: number, numTouches: number): boolean {
        return true;
    }

    public onTouchEnd(x: number, y: number, remainingTouch: number, aDraggedDuringTouch: boolean): boolean {
        return true;
    }

    public onDrag(x: number, y: number, delta: number, buttonState: number): boolean {
        return true;
    }
}
